@if (cookiesEnabled$ | async) {
  @if (video) {
    <div
      class="vimeo"
      [class.was-started]="videoStarted"
      [class.is-playing]="videoPlaying"
      [plyrOptions]="options"
      mat-card-image
      plyr
      (plyrPlaying)="loaded($event)"
      (plyrPlay)="played($event)"
    (plyrPause)="paused($event)"></div>
  }
} @else {
  <div class="cookies-blocked">
    <h2 translate>COOKIE.NOTICE_VIDEO</h2>
  </div>
}
